import AsyncReactSelect from 'react-select/async';
import createSelect from './createSelect';
const AsyncSelect = createSelect(AsyncReactSelect);
export default AsyncSelect;